import { Alert as AlertANTD, AlertProps } from 'antd';

export const Alert = AlertANTD;

export type { AlertProps };
